module.exports = __webpack_public_path__ + "static/media/NGC.6ab1876c.png";